import { PROYECT, api_post } from "services/api";
import { setSnackbar } from "../search/searchActions";

const urlExtend = `${process.env.REACT_APP_URL}${PROYECT}/prices/extend-date`
const urlReset = `${process.env.REACT_APP_URL}${PROYECT}/prices/reset-date`

export const postExtendDate = () => {
    return async (dispatch) => {
        try {
            const resp = await api_post(urlExtend);
            dispatch(setSnackbar(resp.mesagge, "success"));
        } catch (err) {
            const message = err?.message ? err.message : err;
            dispatch(setSnackbar(message));
        }
    }
}

export const postResetDate = () => {
    return async (dispatch) => {
        try {
            const resp = await api_post(urlReset);
            dispatch(setSnackbar(resp.mesagge, "success"));
        } catch (err) {
            const message = err?.message ? err.message : err;
            dispatch(setSnackbar(message));
        }
    }
}